import { Injectable, inject } from "@angular/core";

import { LgTranslateService } from "@logex/framework/lg-localization";
import { FormConfigurationLocalizedText } from "@fhir-api";
import { QualityRuleLocalizedText } from "@logex/expression-validator";

@Injectable({ providedIn: "root" })
export class AppProjectTranslateService {
    private _translateService = inject(LgTranslateService);

    handleLocalizedText(
        localizedText: (FormConfigurationLocalizedText | QualityRuleLocalizedText)[],
        localizationContext: string = "APP",
        messageVariables: Record<string, number | string> = {}
    ): string {
        if (!localizedText.length) {
            return "";
        }
        const i18nLocalization = localizedText.find(text => text.language === "i18n");
        if (i18nLocalization) {
            return this._translateService.translate(
                (localizationContext + "." + i18nLocalization.content!)!.replace("..", "."),
                messageVariables
            );
        }
        const selectedLanguage = this._translateService.getLanguage();
        const messageLanguage = localizedText.find(text => selectedLanguage.includes(text.language!));
        if (messageLanguage) {
            return messageLanguage.content!;
        }
        return localizedText[0].content!;
    }
}
